import { render, staticRenderFns } from "./BizInvoiceinfoSendList.vue?vue&type=template&id=ca035ac2&"
import script from "./BizInvoiceinfoSendList.vue?vue&type=script&lang=js&"
export * from "./BizInvoiceinfoSendList.vue?vue&type=script&lang=js&"
import style0 from "./BizInvoiceinfoSendList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports